// Add-to-calendar helpers for live sessions.
// Events deliberately contain NO zoom link / password — only title, time and
// a generic description pointing users back to the app/website.

const EVENT_DESCRIPTION =
  "Live session — join from the EAU Group app or website.";

// "2026-07-20 15:00:00" / ISO → "20260720T150000Z" (ICS + Google UTC format)
const toCalendarUtc = (mysqlDatetime) => {
  const iso = String(mysqlDatetime).replace(" ", "T");
  const d = new Date(iso.endsWith("Z") ? iso : `${iso}Z`);
  return d
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}/, "");
};

const escapeIcsText = (text) =>
  String(text || "")
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");

// Prefilled Google Calendar "save event" page for a single session.
export const googleCalendarUrl = (session) => {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: session.session_title || "Live Session",
    dates: `${toCalendarUtc(session.start_datetime)}/${toCalendarUtc(
      session.end_datetime,
    )}`,
    details: EVENT_DESCRIPTION,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

// One .ics file with a VEVENT per session (works for 1 or many).
// Apple Calendar / Outlook open it directly; Google Calendar imports it.
export const buildSessionsIcs = (sessions) => {
  const now = toCalendarUtc(new Date().toISOString());
  const events = sessions
    .map((s) =>
      [
        "BEGIN:VEVENT",
        `UID:eau-session-${s.id}-${Date.now()}@eaugroup`,
        `DTSTAMP:${now}`,
        `DTSTART:${toCalendarUtc(s.start_datetime)}`,
        `DTEND:${toCalendarUtc(s.end_datetime)}`,
        `SUMMARY:${escapeIcsText(s.session_title || "Live Session")}`,
        `DESCRIPTION:${escapeIcsText(EVENT_DESCRIPTION)}`,
        "BEGIN:VALARM",
        "TRIGGER:-PT15M",
        "ACTION:DISPLAY",
        "DESCRIPTION:Live session starting soon",
        "END:VALARM",
        "END:VEVENT",
      ].join("\r\n"),
    )
    .join("\r\n");

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//EAU Group//Live Sessions//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    events,
    "END:VCALENDAR",
  ].join("\r\n");
};

export const downloadSessionsIcs = (sessions, filename = "eau-sessions.ics") => {
  const blob = new Blob([buildSessionsIcs(sessions)], {
    type: "text/calendar;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
